import styled from 'styled-components';
import WarningMessage from '../WarningMessage';

export const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid;
  color: ${(props) => props.theme.colors['neutral-100']};
  border-color: ${(props) => props.theme.colors['neutral-30']};
  background-color: ${(props) => props.theme.colors['neutral-10']};
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  line-height: 20px;
  min-height: 48px;
  display: block;

  &:disabled {
    padding: 0;
    border: 0;
  }

  &:active,
  &:focus,
  &:focus-visible {
    outline: none;
    border-width: 2px;
    border-color: ${({ theme }) => theme.colors['primary-60']};
    box-shadow: none;
  }
`;

export const Label = styled.p`
  line-height: 21px;
  font-size: 14px;
  color: ${(props) => props.theme.colors['neutral-80']};
  margin-bottom: 5px;
`;

export const Box = styled.div<{ hasError?: boolean }>`
  position: relative;
  textarea,
  textarea:disabled {
    border: 1px solid;
    border-color: ${(props) => (props.hasError ? '#fc8181' : '#d9d9d9')};
  }
  textarea:disabled {
    padding: 12px;
    opacity: 0.5;
  }
`;

export const CustomWarningMessage = styled(WarningMessage)`
  bottom: -12px;
`;
